import { render } from "./TopImages.vue?vue&type=template&id=023872d8"
import script from "./TopImages.vue?vue&type=script&lang=js"
export * from "./TopImages.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TopImages.vue?vue&type=style&index=0&id=023872d8&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/musubisumu/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__